import { Base, Component, ModelSync, Prop } from '@/vue-property-decorator'
import { ExtractClassProps } from '@/plugins/ant-design-vue/type'
import { Input } from '@/plugins/ant-design-vue/tsx-support'
import { SvgSprite } from '@/components/icon-sprite'
import { Input as _Input } from 'ant-design-vue'
import { ofType } from '@/vue-tsx-support/src'
import style from './style.module.scss'
type Props = {
  preIcon?: SvgSprite
  isRequire?: boolean
}
@Component<PreIconInput>({ name: 'PreIconInput' })
class PreIconInput extends Base<unknown, Props> {
  @Prop()
  private preIcon?: Props['preIcon']
  @Prop()
  private isRequire?: Props['isRequire']
  @ModelSync('value', 'input')
  protected selectValue!: NonNullable<string>
  render() {
    return (
      <Input.Tsx
        v-model={this.selectValue}
        prefix={() => {
          return (
            <div class={style.inputRequire}>
              {this.preIcon && (
                <icon-sprite sprite={this.preIcon}></icon-sprite>
              )}
              {this.isRequire && <span class={style.require}>*</span>}
            </div>
          )
        }}
        onBlur={(e: InputEvent) => this.$emit('blur', e)}
        onChange={(e: InputEvent) => this.$emit('change', e)}
        {...{
          props: {
            ...this.$attrs
          }
        }}
      ></Input.Tsx>
    )
  }
}

export default ofType<ExtractClassProps<_Input>>().convert(PreIconInput)
